(function ($) {
	const blockSlug = 'hometop';
	const initializeBlock = function ($block) {

		// START your JS code
		// Wybierz element SVG do animacji
		//const liquidPath = $block.find('.liquid-path')[0];
		// const liquidPath = $block.find('.acf-block-hometop__bg-image')[0];
		//
		// gsap.to(liquidPath, {
		// 	opacity: 0,
		// 	duration: 0.01,
		// 	ease: 'none',
		// 	stagger: {
		// 		each: 0.1,
		// 		from: 'end',
		// 	},
		// 	yoyo: true,
		// 	repeat: -1
		// });
		//
		// gsap.to(liquidPath, {
		// 	attr: { 'fill-opacity': 0 },
		// 	duration: 0.01,
		// 	ease: 'none',
		// 	stagger: {
		// 		each: 0.1,
		// 		from: 'end',
		// 	},
		// 	yoyo: true,
		// 	repeat: -1
		// });

		// //Utwórz animację falowania turbulencji
		// const turbulence = gsap.timeline({
		// 	repeat: -1, // Powtarzaj animację w nieskończoność
		// 	yoyo: true, // Powrót do początkowego stanu po zakończeniu cyklu
		// });
		//
		// turbulence.to(liquidPath, {
		// 	attr: {
		// 		// Zmieniaj wartości 'baseFrequency' w filtrze turbulencji
		// 		'baseFrequency': '0.04 0.08'
		// 	},
		// 	duration: 0.5, // Czas trwania animacji w sekundach
		// })
		// .to(liquidPath, {
		// 	attr: {
		// 		// Zmieniaj wartości 'baseFrequency' w filtrze turbulencji
		// 		'baseFrequency': '0.2 0.6'
		// 	},
		// 	duration: 0.5, // Czas trwania animacji w sekundach
		// });


		// const scaleAndRotate = gsap.timeline({
		// 	repeat: -1, // Powtarzaj animację w nieskończoność
		// 	yoyo: true, // Powrót do początkowego stanu po zakończeniu cyklu
		// });
		//
		// scaleAndRotate.to(liquidPath, {
		// 	scale: 1.5, // Skaluj element o 50%
		// 	rotation: 360, // Obróć element o 360 stopni
		// 	duration: 2, // Czas trwania animacji w sekundach
		// });
		// END your JS code
	};

	// Initialize each block on page load (front end).
	jQuery(window).on('load', function () {
		$('.acf-block-' + blockSlug).each(function () {

			initializeBlock($(this));

		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=' + blockSlug, initializeBlock);
	}
})(jQuery);
